<template>
  <div
    class="rounded-xl border px-3.5 py-2.5"
    :class="suggested ? 'border-yellow-300 bg-yellow-50' : 'border-gray-200 bg-white'"
    :data-test="`request-${field}`"
  >
    <div class="flex items-center gap-2">
      <span class="text-sm font-bold">{{ t(`claim.declaration_field.${field}`) }}</span>
      <span
        class="whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium"
        :class="suggested ? 'bg-yellow-100 text-yellow-800' : 'bg-blue-50 text-blue-700'"
      >
        {{ suggested ? t("badge_agent") : t("badge_added") }}
      </span>
      <button
        type="button"
        class="ml-auto rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-red-700"
        :aria-label="t('remove_label')"
        :data-test="`remove-${field}`"
        @click="$emit('remove')"
      >
        <XIcon class="h-4 w-4" aria-hidden="true" />
      </button>
    </div>

    <p class="mt-0.5 whitespace-pre-line break-words text-xs text-gray-500" data-test="current-value">
      {{ t("current_value") }}
      <span :class="missing ? 'font-semibold text-yellow-800' : 'text-gray-700'">{{ displayedValue }}</span>
    </p>

    <textarea
      :value="message"
      rows="3"
      :placeholder="t('message_placeholder')"
      class="mt-2 block w-full rounded-lg border-gray-200 text-xs leading-relaxed shadow-xs focus:border-primary focus:ring-primary"
      :data-test="`message-${field}`"
      @input="$emit('update:message', $event.target.value)"
    ></textarea>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { XIcon } from "@heroicons/vue/solid";
import { DATE_FIELDS, FILE_FIELDS, currentValue } from "./complementFields";

export default {
  name: "ClaimComplementRequestItem",

  components: { XIcon },

  setup() {
    const { t, te, d } = useI18n();
    return { t, te, d };
  },

  props: {
    field: {
      type: String,
      required: true,
    },
    // Message propre à ce champ, affiché au client à côté de la question.
    message: {
      type: String,
      default: "",
    },
    // Demande proposée par l'agent général (sinon ajoutée par le gestionnaire).
    suggested: {
      type: Boolean,
      default: false,
    },
    declaration: {
      type: Object,
      default: null,
    },
  },

  emits: ["remove", "update:message"],

  computed: {
    value() {
      return currentValue(this.declaration, this.field);
    },
    missing() {
      return FILE_FIELDS.has(this.field) ? this.value.length === 0 : this.value === null;
    },
    // Réponse actuelle du client, pour que le gestionnaire sache ce qu'il redemande.
    displayedValue() {
      if (FILE_FIELDS.has(this.field)) {
        return this.missing ? this.t("no_file") : this.t("files_count", this.value.length);
      }
      if (this.missing) return this.t("no_answer");
      if (typeof this.value === "boolean") return this.t(this.value ? "yes" : "no");
      if (DATE_FIELDS.has(this.field)) return this.d(new Date(this.value));
      if (this.te(`claim.coverage.${this.value}`)) return this.t(`claim.coverage.${this.value}`);
      return String(this.value);
    },
  },
};
</script>

<i18n src="./ClaimComplementRequestItem.i18n.json"></i18n>
